import { PACKAGE, featureIdsToFlags } from './package_constants'

let PackageUtil = {
  buildDefaultFlagMap (packageFlagList) {
    let defaultFlagMap = {}
    if (!packageFlagList || !packageFlagList.length) {
      return defaultFlagMap
    }
    packageFlagList.forEach((label) => {
      defaultFlagMap[label] = {enabled: false, label: ''}
    })
    return defaultFlagMap
  },
  getFeatureFromPackage (packageObject, featureId) {
    let featureToReturn = {'flags': [], 'enabled': false}
    if (!packageObject || !packageObject.features) {
      return featureToReturn
    }
    packageObject.features.forEach((feature) => {
      if (feature.featureId === featureId) {
        featureToReturn.enabled = feature.enabled
        featureToReturn.label = feature.label
        featureToReturn.flags = feature.flags.slice()
      }
    })
    return featureToReturn
  },
  getFlagsFromPackageFeature (packageObject, featureId, flagList) {
    if (!flagList || !flagList.length) {
      flagList = featureIdsToFlags[featureId]
    }
    let flagMap = this.buildDefaultFlagMap(flagList)
    let feature = this.getFeatureFromPackage(packageObject, featureId)
    feature.flags.forEach((flag) => {
      flagMap[flag.title] = {enabled: flag.enabled, label: flag.label}
    })
    return flagMap
  },
  getPackage (packages, packageId) {
    if (!packageId || !packages || packages.length <= 0) {
      return {}
    }
    let targetPackage = {}
    packages.forEach(packageObj => {
      if (packageObj.packageId === packageId) {
        targetPackage = packageObj
      }
    })
    return targetPackage
  },
  getCoursePlanningPackage (packages) {
    let coursePlanningPackageId = PACKAGE.PACKAGE_IDS.COURSE_PLANNING
    return this.getPackage(packages, coursePlanningPackageId)
  },
  getExploreSearchPackage (packages) {
    let explorePackageId = PACKAGE.PACKAGE_IDS.EXPLORE
    return this.getPackage(packages, explorePackageId)
  },
  getClearlyNextPackage (packages) {
    let clearlyNextPackageId = PACKAGE.PACKAGE_IDS.CLEARLY_NEXT
    return this.getPackage(packages, clearlyNextPackageId)
  },
  getFlagFromFeature (feature, flagName) { // NOTE: based on flag.title comparison, not id
    let targetFlag = {}
    if (!feature || !feature.flags || !feature.flags.length) {
      return {}
    }
    feature.flags.forEach(flag => {
      if (flag.title === flagName) {
        targetFlag = flag
      }
    })
    return targetFlag
  }
}

export { PackageUtil }



// WEBPACK FOOTER //
// ./src/package_utils.js